import type { StatusTone } from '@skylabs-digital/backoffice-kit';
import type { ErrorCategory } from '../schemas/notification.schema';

export interface ErrorCategoryInfo {
  /** Short label for badges and filter pills. */
  label: string;
  /** One-line explanation, used as a tooltip (`title`) on the badge. */
  description: string;
  tone: StatusTone;
}

/**
 * RFC 0002 §2 (Fase 1) — una entrada por categoría de error del proveedor.
 * transient/quota son reintentables automáticamente (tono warning); el resto
 * no se reintenta solo (tono danger).
 */
export const ERROR_CATEGORY_INFO: Record<ErrorCategory, ErrorCategoryInfo> = {
  transient: {
    label: 'Transient',
    description: 'Temporary provider error; retried automatically.',
    tone: 'warning',
  },
  quota: {
    label: 'Quota exceeded',
    description: 'Provider quota exceeded; retried later.',
    tone: 'warning',
  },
  config: {
    label: 'Misconfigured',
    description: 'Provider misconfigured (API key); fix and retry all.',
    tone: 'danger',
  },
  recipient: {
    label: 'Invalid recipient',
    description: 'Recipient address is invalid; not retried.',
    tone: 'danger',
  },
  permanent: {
    label: 'Permanent failure',
    description: 'Permanent provider error; not retried.',
    tone: 'danger',
  },
  bounce: {
    label: 'Bounce',
    description: "Recipient's mailbox bounced the message; not retried.",
    tone: 'danger',
  },
  complaint: {
    label: 'Complaint',
    description: 'Recipient marked the message as spam; not retried.',
    tone: 'danger',
  },
};

export const ERROR_CATEGORY_OPTIONS = Object.keys(ERROR_CATEGORY_INFO) as ErrorCategory[];
